import React, { useEffect, useState } from 'react';
import moment from "moment";

import StatusCard from '../../../../../Common/DesignSystem/StatusCard';
import { Heading6, CaptionMedium, P3Bold } from '../../../../../Common/DesignSystem/Text';
import Button from '../../../../../Common/DesignSystem/Button';
import colours from '../../../../../Common/DesignSystem/Colours';
import Icon from '../../../../../Common/DesignSystem/Icons/Icon';

export const VehicleRemindersCard = ({ reminders, vehicle, history, match }) => {
	const [activatedReminders, setActivatedReminders] = useState([]);
	const [upcomingReminders, setUpcomingReminders] = useState([]);
	const [completedReminders, setCompletedReminders] = useState([]);

	const reminderCategories = ['Service', 'Insurance', 'License', 'Termination'];
	const iconContainerStyle = { marginRight: 4, borderRadius: '8px', color: colours.primary.blue, backgroundColor: colours.functional.hover_secondaryblue};
	const greenIconContainerStyle = { marginRight: 4, borderRadius: '8px', color: colours.accent.validate_green, backgroundColor: colours.accent.light_green};

	useEffect(() => {
		setActivatedReminders([]);
		setUpcomingReminders([]);
		setCompletedReminders([]);

		reminders?.active.forEach((reminder)=> {
			const isActivatedReminder = (reminder.Remind_Date && moment().isAfter(moment(reminder.Remind_Date))) || (reminder.Remind_km && reminder.Remind_km < vehicle.odometer);

			if (isActivatedReminder) {
				setActivatedReminders(prevState => [...prevState, reminder]);
			} else {
				setUpcomingReminders(prevState => [...prevState, reminder]);
			}
		});

		setCompletedReminders(reminders?.completed);
	}, [reminders]);

    const addReminder = () => {
		const { url, params: { v_id } } = match;
        history.push(`${url}/vehiclereminder/${v_id}`);
    }

	return (
		<div className="overlay_header_bordered">
			<div style={{display: 'flex', flex: 1, flexDirection: 'column', justifyContent: 'flex-start'}}>
				<Heading6 style={{color: colours.primary.grey01}}>Reminders</Heading6>
				<div style={{marginTop: 12}}>
					{activatedReminders.length > 0 && (
						activatedReminders.map((reminder) => (
							<div key={reminder.REMIND_ID} style={{marginBottom: 16}}>
								{reminder.Remind_Date && (
									<StatusCard type="reminder" activated={{category: reminderCategories[reminder.Category], remind_date: reminder.Remind_Date}} />
								)}
								{reminder.Remind_km && (
									<StatusCard type="reminder" activated={{category: reminderCategories[reminder.Category], remind_km: reminder.Remind_km}} />
								)}
							</div>
						))
					)}

					{upcomingReminders.length > 0 && (
						<>
							<div style={{display: 'flex', flex: 1, flexDirection: 'row', justifyContent: 'flex-start', alignItems: 'center', marginTop: 12}}>
								<Icon name="Upcoming" size={16} style={iconContainerStyle}/>
								<CaptionMedium style={{color: colours.primary.grey02}}>Upcoming Reminders:</CaptionMedium>
							</div>
							{upcomingReminders.map((reminder) => (
								<div key={reminder.REMIND_ID}>
									{reminder.Remind_Date && (
										<div style={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between', marginTop: 8, alignItems: 'center'}}>
											<P3Bold>{reminderCategories[reminder.Category]}</P3Bold>
											<P3Bold>{moment(reminder.Remind_Date).format("MMM DD, YYYY")}</P3Bold>
										</div>
									)}
									{reminder.Remind_km && (
										<div style={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between', marginTop: 8, alignItems: 'center'}}>
											<P3Bold>{reminderCategories[reminder.Category]}</P3Bold>
											<P3Bold>{new Intl.NumberFormat().format(reminder.Remind_km) + ' KM'}</P3Bold>
										</div>
									)}
								</div>
							))}
						</>
					)}

					{completedReminders?.length > 0 && (
						<>
							<div style={{display: 'flex', flex: 1, flexDirection: 'row', justifyContent: 'flex-start', alignItems: 'center', marginTop: 12}}>
								<Icon name="Check" size={16} style={greenIconContainerStyle}/>
								<CaptionMedium style={{color: colours.primary.grey02}}>Completed Reminders:</CaptionMedium>
							</div>
							{completedReminders.map((reminder) => (
									<div key={reminder.REMIND_ID}>
										{reminder.Remind_Date ? <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between', marginTop: 8}}>
											<P3Bold>{reminderCategories[reminder.Category]}</P3Bold>
											<P3Bold>{moment(reminder.Remind_Date).format("MMM DD, YYYY")}</P3Bold>
										</div> : null}
										{reminder.Remind_km ? <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between', marginTop: 8}}>
											<P3Bold>{reminderCategories[reminder.Category]}</P3Bold>
											<P3Bold>{new Intl.NumberFormat().format(reminder.Remind_km) + ' KM'}</P3Bold>
										</div> : null}
									</div>
								)
							)}
						</>
					)}

					{!activatedReminders?.length && !upcomingReminders?.length && (!completedReminders || !completedReminders?.length) && (
						<StatusCard key="reminder" type="reminder"/>
					)}
				</div>
				<div style={{flex: 1, display: 'flex', justifyContent: 'flex-end', flexDirection: 'column', marginTop: 16}}>
					<Button secondary label="Add Reminder" leading_ic="Reminder" onClick={addReminder}/>
				</div>
			</div>
		</div>
	)
};